import React, { useEffect, useState } from 'react';

import { Box, Grid, Typography } from '@mui/material';

import API from 'api/API';
import { KitOrder, OrderListQuery, OrderSearchResponse } from 'api/Responses/OrderResponses';
import Page from 'components/Page';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import { useLanguage } from 'context/AppContext';

import AllDeliveries from '../molecules/AllDeliveries';
import DeliveryPortalMenu from '../molecules/DeliveryPortalMenu';
import FilterModal from '../molecules/FilterModal';
import InspectionMetaData from '../molecules/InspectionMetaData';

const DeliveryPortalPage: React.FC = () => {
  const [language] = useLanguage();
  const [orderResponse, setOrderResponse] = useState<OrderSearchResponse | null>(null);
  const [rows, setRows] = useState<KitOrder[]>([]);
  const [pageState, setPageState] = useState<'initalizing' | 'viewing' | 'filtering'>('initalizing');
  const [filters, setFilters] = useState<Omit<OrderListQuery, 'last_id'>>({});

  const getData = async (filtersChanged: boolean) => {
    try {
      const response = await API.orders.getReceivingList({
        ...filters,
        last_id: filtersChanged ? undefined : orderResponse?.last_id,
      });
      setOrderResponse(response);
      if (response) {
        setRows(rows => (filtersChanged ? response.kit_orders : rows.concat(response.kit_orders)));
        setPageState('viewing');
      }
    } catch (e) {
      setOrderResponse(null);
    } finally {
      setPageState('viewing');
    }
  };

  useEffect(() => {
    setPageState('initalizing');
    getData(true);
    /* eslint-disable */
    /* We explicitly only want this to be triggered when filters changes */
  }, [filters]);

  return (
    <Page>
      <Box sx={{ flexDirection: 'column', height: '100%', display: 'flex', overflow: 'hidden' }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" component="h1">
              {language.DeliveryPortal.Title}
            </Typography>
          </Grid>
          <Grid item>
            <DeliveryPortalMenu onFilter={() => setPageState('filtering')} />
          </Grid>
        </Grid>
        <Box mb={4} />
        {pageState === 'initalizing' ? (
          <PageSpinner />
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
            <InspectionMetaData stats={orderResponse?.stats ?? null} />
            <Box mb={4} />
            <AllDeliveries
              data={rows}
              onFetchRows={() => getData(false)}
              lastPage={orderResponse?.last_page ?? false}
            />
            <FilterModal
              isShown={pageState === 'filtering'}
              onClose={() => setPageState('viewing')}
              setFilters={setFilters}
              filters={filters}
            />
          </Box>
        )}
      </Box>
    </Page>
  );
};
export default DeliveryPortalPage;
